import React from "react";
import PropTypes from "prop-types";

import LockingContainer from "editor/containers/LockingContainer";
import ReadyForEditsContainer from "editor/containers/ReadyForEditsContainer";
import ScheduledContainer from "editor/containers/ScheduledContainer";
import ContentOutOfDateContainer from "editor/containers/ContentOutOfDateContainer";
import DifferentTabLockedContainer from "editor/containers/DifferentTabLockedContainer";

export default function ReadOnlyWrapper({ status, id, children }) {
  return (
    <ContentOutOfDateContainer>
      <ScheduledContainer status={status}>
        <ReadyForEditsContainer>
          <LockingContainer id={id}>
            <DifferentTabLockedContainer>
              {children}
            </DifferentTabLockedContainer>
          </LockingContainer>
        </ReadyForEditsContainer>
      </ScheduledContainer>
    </ContentOutOfDateContainer>
  );
}

ReadOnlyWrapper.propTypes = {
  id: PropTypes.string,
  children: PropTypes.node.isRequired,
  status: PropTypes.string,
};
